<template>
  <div class="textfield" :class="{ 'textfield--focused': isInputFocused }" @click="onClick($event)">
    <input
      ref="input"
      data-test-header-textfield-input
      class="textfield__input"
      :placeholder="placeholder"
      :value="value"
      @keyup.enter="$emit('enter', $event)"
      @input="$emit('input', $event)"
      @focus="isInputFocused = true"
      @blur="isInputFocused = false"
    />
    <slot />
  </div>
</template>

<script lang="ts">
import type { TextfieldData } from './types/Textfield';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TextField',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  data(): TextfieldData {
    return {
      isInputFocused: false
    };
  },
  methods: {
    onClick(event: Event): void {
      this.focusInput();
      this.$emit('click', event);
    },
    focusInput(): void {
      if (this.$refs.input) {
        (this.$refs.input as HTMLInputElement).focus();
      }
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all.scss';
@import 'node_modules/foundation-sites/scss/util/util';

.textfield {
  cursor: text;
  border: rem-calc(1px) solid rgba(204, 204, 204, 1);
  border-radius: rem-calc(8px);
  display: flex;
  align-items: center;
  padding: rem-calc(10px) rem-calc(16px);
  color: rgba(34, 37, 39, 1);
  box-sizing: border-box;

  &:not(&--focused) {
    &:hover {
      border-color: rgba(164, 164, 164, 1);
    }
  }

  &--focused {
    border-color: rgba(91, 98, 103, 1);
  }

  &__input {
    font-family: $body-font-family;
    font-weight: 400;
    font-size: rem-calc(16px);
    line-height: rem-calc(24px);
    font-feature-settings:
      'pnum' on,
      'lnum' on;
    color: rgba(34, 37, 39, 1);
    flex-grow: 1;
    border: none;
    appearance: none;
    outline: none;

    &::placeholder {
      color: rgba(164, 164, 164, 1);
    }
  }
}
</style>
